import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const Create = () => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultDateValue = new Date(date).toISOString().split("T")[0];

  // const navigate = useNavigate();

  const { id, type } = useParams();
  const [inputs, setInputs] = useState({
    status: "received",
    // date: defaultDateValue,
    // challan_date: defaultDateValue,
  });
  const [error, setError] = useState({});
  const [list, setList] = useState([]);
  const [product, setProduct] = useState({});
  const [unit, setUnit] = useState({});
  const [location, setLocation] = useState({});
  const [factory, setFactory] = useState({});
  const [lastGrnNo, setLastGrnNo] = useState("");
  const [processedVendorKeys, setProcessedVendorKeys] = useState({});
  const [submittingVendorKey, setSubmittingVendorKey] = useState(null);

  const vendorGroups = useMemo(() => {
    const items = Array.isArray(list) ? list : [];
    const groupsMap = new Map();

    items.forEach((item, index) => {
      const vendorId =
        item.vendor_id ??
        item.vendorId ??
        item.vendor?.id ??
        item.work_order_items?.vendor?.id ??
        null;
      const vendorName =
        item.vendor_name ??
        item.vendor ??
        item.vendor?.name ??
        item.work_order_items?.vendor?.name ??
        "Unknown Vendor";

      const key =
        vendorId !== null && vendorId !== undefined
          ? String(vendorId)
          : `unknown:${vendorName || "Unknown Vendor"}`;

      const existing = groupsMap.get(key) || {
        key,
        vendorId,
        vendorName,
        indices: [],
      };
      existing.indices.push(index);
      existing.vendorName = existing.vendorName || vendorName;
      existing.vendorId = existing.vendorId ?? vendorId;
      groupsMap.set(key, existing);
    });

    return Array.from(groupsMap.values());
  }, [list]);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  // const handleReceiveQty = (e, index) => {
  //   const { name, value } = e.target; // Chanages Experience Input Name and Value
  //   const inputInfo = [...list]; // Defined Experience State All Information into List Variable

  //    // Update the corresponding field value
  // inputInfo[index][name] = value;

  // // Calculate accepted_qty as PO Qty - Rejected Qty
  // if (name === "rejected_qty") {
  //   let calculatedReceiveQty =
  //     parseFloat(inputInfo[index].qty) - parseFloat(value);

  //   // Ensure received_qty does not exceed qty
  //   if (calculatedReceiveQty > parseFloat(inputInfo[index].qty)) {
  //     calculatedReceiveQty = parseFloat(inputInfo[index].qty);
  //   }

  //   inputInfo[index].receive_qty = calculatedReceiveQty;
  // }

  // // Calculate total_amount based on the accepted_qty and unit_price
  // inputInfo[index].total_amount =
  //   parseFloat(inputInfo[index].unit_price) *
  //   parseFloat(inputInfo[index].receive_qty);

  // // Update the list state
  // setList(inputInfo);

  //   // if (
  //   //   parseFloat(e.target.getAttribute("data-due_qty")) >=
  //   //   parseFloat(e.target.value)
  //   // ) {
  //   //   inputInfo[index][name] = value;
  //   //   inputInfo[index].total_amount = inputInfo[index].unit_price * value;

  //   // } else {
  //   //   alert("Qty Not Available on Purchase Order");
  //   //   inputInfo[index][name] = 0;
  //   //   inputInfo[index].total_amount = 0; // Reset total_amount if invalid

  //   // }

  //   setList(inputInfo);
  // };

  const handleReceiveQty = (e, index) => {
    const { name, value } = e.target;
    const inputInfo = [...list];

    // Allow only numbers and a single dot
    const sanitizedValue = value.replace(/[^0-9.]/g, '').replace(/^(\d*\.\d*).*$/, '$1');

    // Save as string for input, but use parseFloat for calculations
    let inputValue = sanitizedValue === "" ? "" : parseFloat(sanitizedValue);

    const maxQty =
      parseFloat(inputInfo[index].qty || 0) -
      parseFloat(inputInfo[index].received_qty || 0);

    // Ensure that the input value is not less than zero
    if (inputValue < 0) {
      inputValue = 0;
    }
    if(name === 'rejected_qty'){
      if(value > (maxQty - inputInfo[index].accepted_qty)){
        Swal.fire({
          title: "Rejected Qty Must Be Less Than Previous Qty - Accepted Qty",
          icon: "warning",
          showCancelButton: false,
          cancelButtonColor: "#d33",
        }).then((result) => {
          console.log(result);
        });
        inputValue = 0;
      }
    }

    // Ensure that the input value does not exceed the qty
    if (inputValue > maxQty) {
      console.log(inputValue, maxQty);
      inputValue = 0;

      Swal.fire({
        title: "Qty Not Available on Purchase Order",
        icon: "warning",
        showCancelButton: false,
        cancelButtonColor: "#d33",
      }).then((result) => {
        console.log(result);
      });
    }

    // Update the corresponding field value
    inputInfo[index][name] = sanitizedValue;

    // Calculate received_qty as PO Qty - Rejected Qty
    // if (name === "rejected_qty") {
    //   inputInfo[index].accepted_qty = maxQty - inputValue;
    // } else if (name === "accepted_qty") {
    //   inputInfo[index].rejected_qty = maxQty - inputValue;
    // }

    // Calculate total_amount based on the valid received_qty and unit_price
    inputInfo[index].total_amount =
      parseFloat(inputInfo[index].unit_price || 0) *
      parseFloat(inputInfo[index].accepted_qty || 0);

    // Update the list state
    setList(inputInfo);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // const fetchSPRData = async (purchaseRequisitionArtId) => {
  //   try {
  //     const res = await Http.get(
  //       `/store-purchase-requisition-art/${purchaseRequisitionArtId}`
  //     );
  //     const sprData = res.data;

  //     // Update the inputs with SPR data
  //     setInputs((values) => ({
  //       ...values,
  //       spr_no: sprData.receipt_no,
  //       spr_date: sprData.date,
  //     }));

  //      // Update the list to include the required_qty from SPR API
  //   const updatedList = list.map((item) => {
  //     const matchingSprItem = sprData.items.find(
  //       (sprItem) => sprItem.product_id === item.product_id
  //     );

  //     return {
  //       ...item,
  //       required_qty: matchingSprItem ? matchingSprItem.required_qty : item.required_qty,
  //     };
  //   });

  //   setList(updatedList);

  //   } catch (error) {
  //     console.error("Error fetching SPR data:", error);
  //   }
  // };

  // const fetchSPRData = async (purchaseRequisitionArtId) => {
  //   try {
  //     const res = await Http.get(
  //       `/store-purchase-requisition-art/${purchaseRequisitionArtId}`
  //     );
  //     const sprData = res.data;

  //     // Update the inputs with SPR data
  //     setInputs((values) => ({
  //       ...values,
  //       spr_no: sprData.receipt_no,
  //       spr_date: sprData.date,
  //       store_dept_id: sprData.created_by.depot_id,
  //     }));

  //     // Update the list to include the required_qty from SPR API
  //     setList((prevList) =>
  //       prevList.map((item) => {
  //         const matchingSprItem = sprData.items.find(
  //           (sprItem) => sprItem.product_id === item.product_id
  //         );

  //         return {
  //           ...item,
  //           required_qty: matchingSprItem
  //             ? matchingSprItem.required_qty
  //             : item.required_qty,
  //         };
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Error fetching SPR data:", error);
  //   }
  // };

  // const fetchData = () => {
  //   const listInfo = [];
  //   if (type == "po") {
  //     Http.get("/work-order/" + id).then((res) => {
  //       const listInfo = [];
  //       Object.keys(res.data.items).forEach((key) => {
  //         listInfo.push({
  //           item_id: res.data.items[key].id,
  //           product_id: res.data.items[key].product_id,
  //           unit_id: res.data.items[key].unit_id,
  //           unit_qty: res.data.items[key].unit.qty,
  //           unit_price: res.data.items[key].unit_price,
  //           qty: res.data.items[key].qty,
  //           actual_qty: res.data.items[key].actual_qty,
  //           desc: "",
  //           prev_rcv:
  //             parseFloat(res.data.items[key].received_qty) > 0
  //               ? res.data.items[key].received_qty
  //               : "0",
  //         });
  //       });
  //       setList(listInfo);
  //     });
  //   } else if (type == "dp") {
  //     Http.get("/direct-purchase/" + id).then((res) => {
  //       console.log(res.data);
  //       const listInfo = [];
  //       Object.keys(res.data.items).forEach((key) => {
  //         listInfo.push({
  //           item_id: res.data.items[key].id,
  //           product_id: res.data.items[key].product_id,
  //           unit_id: res.data.items[key].unit_id,
  //           unit_qty: res.data.items[key].product.unit.qty,
  //           unit_price: res.data.items[key].price,
  //           qty: res.data.items[key].qty,
  //           receive_qty: res.data.items[key].qty,
  //           actual_qty: res.data.items[key].qty,
  //           desc: "",
  //           prev_rcv:
  //             parseFloat(res.data.items[key].received_qty) > 0
  //               ? res.data.items[key].received_qty
  //               : "0",
  //         });
  //       });
  //       setList(listInfo);
  //       // If purchase_requisition_art_id is available, fetch the SPR data
  //       if (res.data.purchase_requisition_art_id) {
  //         fetchSPRData(res.data.purchase_requisition_art_id);
  //       }
  //     });
  //   }

  //   Http.get("/product").then((res) => {
  //     setProduct(res.data);
  //   });
  //   Http.get("/last-grn-no").then((res) => {
  //     setLastGrnNo(res.data);
  //   });
  //   Http.get("/last-code-increment-by-one/grns/challan_no/CH").then((res) => {
  //     setInputs((values) => ({ ...values, ["challan_no"]: res.data }));
  //   });
  //   Http.get("/location").then((res) => {
  //     setLocation(res.data);
  //   });
  //   Http.get("/factory").then((res) => {
  //     setFactory(res.data);
  //   });
  //   Http.get("/unit").then((res) => {
  //     setUnit(res.data);
  //   });
  // };

  const fetchData = async () => {
    if (type === "po") {
      const res = await Http.get("/work-order/" + id);
      const listInfo = res.data.items.map((item) => ({
        item_id: item.id,
        product_id: item.product_id,
        product_name: item.product.name,
        vendor_id: item.vendor?.id ?? item.work_order_items?.vendor?.id ?? null,
        vendor_name:
          item.vendor?.name ??
          item.work_order_items?.vendor?.name ??
          "Unknown Vendor",
        receive_date: defaultDateValue,
        unit_id: item.unit_id,
        unit_qty: item.unit.qty,
        unit_price: item.unit_price,
        qty: item.qty,
        actual_qty: item.actual_qty,
        desc: "",
        prev_rcv: parseFloat(item.received_qty) > 0 ? item.received_qty : "0",
        received_qty: item.received_qty ?? 0,
      }));
      setList(listInfo || []);
    } else if (type === "dp") {
      const res = await Http.get("/direct-purchase/" + id);
      const listInfo = res.data.items.map((item) => ({
        item_id: item.id,
        product_id: item.product_id,
        product_name: item.product.name,
         purchase_date: item.date,
        vendor_id: item.vendor?.id ?? null,
        vendor_name: item.vendor?.name ?? "Unknown Vendor",
        receive_date: defaultDateValue,
        unit_id: item.unit_id,
        unit_qty: item?.product?.unit?.qty,
        unit_price: item.price,
        required_qty: item.purchase_requisition_art_item.required_qty,
        qty: item.qty,
        accepted_qty:
          parseFloat(item.qty || 0) - parseFloat(item.received_qty || 0),
        actual_qty: item.qty,
        desc: "",
        prev_rcv: parseFloat(item.received_qty) > 0 ? item.received_qty : "0",
        received_qty: item.received_qty ?? 0,
        total_amount:
          parseFloat(item.price || 0) *
          (parseFloat(item.qty || 0) - parseFloat(item.received_qty || 0)),
      }));
      setList(listInfo || []);

      // Set the po_no based on the id fetched from /direct-purchase/
      setInputs((values) => ({
        ...values,
        po_no: res.data.id, // Assuming the direct purchase ID is used as po_no
        spr_no: res.data.purchase_requisition_art.receipt_no,
        spr_date: res.data.purchase_requisition_art.date,
      }));

      // If purchase_requisition_art_id is available, fetch the SPR data
      // if (res.data.purchase_requisition_art_id) {
      //   await fetchSPRData(res.data.purchase_requisition_art_id); // Wait for SPR data to be fetched
      // }
    }

    // Fetch other necessary data
    // const productRes = await Http.get("/product");
    // setProduct(productRes.data);
    const grnNoRes = await Http.get("/last-grn-no");
    setLastGrnNo(grnNoRes.data);
    const challanRes = await Http.get(
      "/last-code-increment-by-one/grns/challan_no/CH"
    );
    setInputs((values) => ({ ...values}));
    const locationRes = await Http.get("/location");
    setLocation(locationRes.data);
    const factoryRes = await Http.get("/factory");
    setFactory(factoryRes.data);
    const unitRes = await Http.get("/unit");
    setUnit(unitRes.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const formSubmit = () => {
  //   inputs.items = list;
  //   inputs.work_order_id = id;
  //   inputs.grn_no = lastGrnNo;
  //   inputs.type = type;
  //   inputs.id = id;

  //   Http.post("/grn", inputs)
  //     .then((res) => {
  //       navigate("/direct-purchase", {
  //         state: { message: res.data.message, type: "success" },
  //       });
  //     })
  //     .catch(function (e) {
  //       setError(e.response.data.errors);
  //     });
  // };

  const submitVendorGroup = async (group) => {
    if (!group?.indices?.length) {
      return;
    }

    const groupVendorId = group.vendorId;
    if (groupVendorId === null || groupVendorId === undefined) {
      Swal.fire({
        title: "Vendor is required",
        text: "Cannot submit a GRN group without vendor id.",
        icon: "warning",
        showCancelButton: false,
        cancelButtonColor: "#d33",
      });
      return;
    }

    setSubmittingVendorKey(group.key);
    setError({});

    try {
      const itemsForVendor = group.indices.map((idx) => {
        const item = list[idx];
        return {
          ...item,
          vendor_id: item.vendor_id ?? groupVendorId,
          // receive_date: item.receive_date || inputs.date || defaultDateValue,
          spr_qty: item.required_qty,
          po_qty: item.qty,
        };
      });

      const anyMissingVendor = itemsForVendor.some(
        (it) => it.vendor_id === null || it.vendor_id === undefined
      );
      if (anyMissingVendor) {
        Swal.fire({
          title: "Vendor is required",
          text: "Every submitted item must include vendor id.",
          icon: "warning",
          showCancelButton: false,
          cancelButtonColor: "#d33",
        });
        setSubmittingVendorKey(null);
        return;
      }

      const payload = {
        ...inputs,
        items: itemsForVendor,
        work_order_id: id,
        grn_no: lastGrnNo,
        type,
        id,
      };

      const res = await Http.post("/grn", payload);

      setProcessedVendorKeys((prev) => ({ ...prev, [group.key]: true }));
      Swal.fire({
        title: "Received",
        text: res?.data?.message || "Vendor items received successfully.",
        icon: "success",
        showCancelButton: false,
        cancelButtonColor: "#d33",
      });

      const grnNoRes = await Http.get("/last-grn-no");
      setLastGrnNo(grnNoRes.data);
      const challanRes = await Http.get(
        "/last-code-increment-by-one/grns/challan_no/CH"
      );
      setInputs((values) => ({ ...values, challan_no: challanRes.data }));
    } catch (e) {
      setError(e?.response?.data?.errors || {});
      Swal.fire({
        title: "Failed",
        text: e?.response?.data?.message || "Failed to receive vendor items.",
        icon: "error",
        showCancelButton: false,
        cancelButtonColor: "#d33",
      });
    } finally {
      setSubmittingVendorKey(null);
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">MRR with QC </h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">MRR with QC</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <label>Date <span className="tx-danger">*</span></label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date || ""}
                  onChange={handleChange}
                  placeholder="Input Date"
                />
              </div>
              <div className="col-lg">
                <label>Challan Date <span className="tx-danger">*</span></label>
                <input
                  type="date"
                  className="form-control"
                  name="challan_date"
                  value={inputs.challan_date || ""}
                  onChange={handleChange}
                  placeholder="Input Challan Date"
                />
              </div>
              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>GRN No</label>
                <input
                  type="text"
                  className="form-control"
                  name="grn_no"
                  value={lastGrnNo || "00001"}
                  onChange={handleChange}
                  placeholder="Input GRN No"
                />
              </div>
              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>SPR No</label>
                <input
                  type="text"
                  className="form-control"
                  name="spr_no"
                  value={inputs.spr_no || ""}
                  disabled
                />
              </div>
              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>SPR Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="spr_date"
                  value={inputs.spr_date || ""}
                  disabled
                />
              </div>

              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>Challan No <span className="tx-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="challan_no"
                  value={inputs.challan_no}
                  onChange={handleChange}
                  placeholder="Input Challan No"
                />
              </div>
              {/* <div className="col-lg">
                <label htmlFor="">Location</label>
                <select
                  className="form-control"
                  name="company_location_id"
                  onChange={handleChange}
                >
                  <option value="">Select Location</option>
                  {Array.from(location).map((item, index) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label htmlFor="">Factory</label>
                <select
                  className="form-control"
                  name="factory_id"
                  onChange={handleChange}
                >
                  <option value="">Select Factory</option>
                  {Array.from(factory).map((item, index) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="col-lg mg-t-10 mg-lg-t-0">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  onChange={handleChange}
                >
                  <option
                    value="received"
                    selected={inputs.status === "received" ? true : false}
                  >
                    Received
                  </option>
                  {/* <option
                    value="active"
                    selected={inputs.status === "active" ? true : false}
                  >
                    Active
                  </option>
                  <option
                    value="inactive"
                    selected={inputs.status === "inactive" ? true : false}
                  >
                    inactive
                  </option> */}
                  <option
                    value="completed"
                    selected={inputs.status === "completed" ? true : false}
                  >
                    Completed
                  </option>
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12">
                {vendorGroups.length === 0 ? (
                  <div className="alert alert-info mb-0">
                    No line items available.
                  </div>
                ) : (
                  vendorGroups.map((group) => {
                    const isProcessed = !!processedVendorKeys[group.key];
                    const isSubmitting = submittingVendorKey === group.key;
                    const buttonDisabled = isProcessed || isSubmitting;
                    const buttonText = isProcessed
                      ? "Received"
                      : isSubmitting
                      ? "Receiving..."
                      : "Receive";

                    return (
                      <div
                        key={group.key}
                        className="card mb-3"
                        style={{ border: "1px solid #e3e3e3" }}
                      >
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <div>
                            <strong>Vendor:</strong>{" "}
                            {group.vendorName || "Unknown Vendor"}
                            {group.vendorId !== null &&
                            group.vendorId !== undefined
                              ? ` (ID: ${group.vendorId})`
                              : ""}
                          </div>
                          <button
                            className={
                              isProcessed
                                ? "btn btn-success"
                                : "btn btn-primary"
                            }
                            onClick={() => submitVendorGroup(group)}
                            disabled={buttonDisabled}
                          >
                            <i className="fa fa-send mg-r-10"></i> {buttonText}
                          </button>
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive">
                            <table className="table table-sm align-items-center mb-0">
                              <thead>
                                <tr>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Product
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Receive Date
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Unit Price
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    SPR Qty
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    PO Qty
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Prev Receive
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Moisture
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Accepted Qty
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Rejected Receive
                                  </th>
                                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                    Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {group.indices.map((i) => {
                                  const x = list[i];
                                  return (
                                    <tr key={x?.item_id ?? i}>
                                      <td className="ps-2">
                                        {x?.product_name || ""}
                                      </td>
                                      <td>
                                        <input
                                          type="date"
                                          className="form-control"
                                          name="purchase_date"
                                          value={
                                            x?.purchase_date ||
                                            inputs.date ||
                                            defaultDateValue
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="unit_price"
                                          disabled
                                          value={x?.unit_price || ""}
                                          onChange={(e) =>
                                            handleInputChange(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="required_qty"
                                          disabled
                                          value={x?.required_qty || ""}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="qty"
                                          disabled
                                          value={x?.qty || ""}
                                          onChange={(e) =>
                                            handleInputChange(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="prev_rcv"
                                          disabled
                                          value={x?.prev_rcv || ""}
                                          onChange={(e) =>
                                            handleInputChange(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ))
                                            }
                                            className="form-control"
                                            name="moisture"
                                            value={x?.moisture || ""}
                                            onChange={(e) =>
                                              handleInputChange(e, i)
                                            }
                                          />
                                          <span className="input-group-text">
                                            %
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="accepted_qty"
                                          value={x?.accepted_qty || ""}
                                          onChange={(e) =>
                                            handleReceiveQty(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="rejected_qty"
                                          value={x?.rejected_qty || ""}
                                          data-due_qty={
                                            parseFloat(x?.qty || 0) -
                                            parseFloat(x?.prev_rcv || 0)
                                          }
                                          onChange={(e) =>
                                            handleReceiveQty(e, i)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(
                                                /\D/g,
                                                ""
                                              ))
                                          }
                                          className="form-control"
                                          name="total_amount"
                                          value={x?.total_amount || ""}
                                          onChange={(e) =>
                                            handleReceiveQty(e, i)
                                          }
                                          disabled
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
